import React from 'react'
import PropTypes from 'prop-types'
import Snackbar from 'components/snackbar'
import Routes from 'routes/routes'

import 'less/app.less'
import 'less/snackbar.less'


class App extends React.Component {
  render () {
    return (
      <div>
          <Routes   props={this.props}/>
          <Snackbar />
    </div>
    )
  }
}
 
App.propTypes = {
  children: PropTypes.element,
}

export default App
